import { useEffect, useState } from "react"

import { useLoading } from "@/provider/loading/useLoading"
import apiService, { HttpError } from "@/provider/rest"

export type Invitation = {
	salonID: number
	userID: string
	email: string
	initPassword: string
	isPasswordSetByUser: boolean
}

const useInvitation = (secretValue: string) => {
	const { startLoading } = useLoading()
	const [invitation, setInvitation] = useState<Invitation | null>(null)
	const [isValidLink, setIsValidLink] = useState<boolean | null>(null)

	useEffect(() => {
		const stopLoading = startLoading()
		apiService
			.post(
				"/go.idp.public.v1.IdpPublicService/GetSalonUserInvitation",
				{
					secret_value: secretValue,
				},
				startLoading,
				process.env.REACT_APP_IDP_PUBLIC_API_URL,
				false
			)
			.then((res) => {
				const invitation: Invitation = {
					salonID: res.salonId,
					userID: res.userId,
					email: res.email,
					initPassword: res.initPassword,
					isPasswordSetByUser: res.isPasswordSetByUser ?? false, // connect 使っている都合で、false の場合は undefined になってしまう
				}
				setInvitation(invitation)
				setIsValidLink(true)
			})
			.catch((e: HttpError) => {
				if (e.statusCode === 404) {
					setIsValidLink(false)
					return
				}
				console.log("unexpected error while fetching salon user invitation", e)
				throw e
			})
			.finally(() => stopLoading())
	}, [secretValue, startLoading])

	return {
		invitation,
		isValidLink,
	}
}

export default useInvitation
